(function () {
  function closeDrawer(drawer) {
    if (drawer) drawer.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-bm-header-1-close]');
    if (!closeButton) return;

    closeDrawer(closeButton.closest('[data-bm-header-1-drawer]'));
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-bm-header-1-drawer][open]').forEach(closeDrawer);
  });
})();
